/* tslint:disable */
/* eslint-disable */
/**
 * Prometeia - Profiling API
 * Profiling - Backend API
 *
 * The version of the OpenAPI document: API v1
 * Contact: emanuele.barrano@prometeia.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CheckCoherenceResponseAnswerResponse
 */
export interface CheckCoherenceResponseAnswerResponse {
    /**
     * 
     * @type {string}
     * @memberof CheckCoherenceResponseAnswerResponse
     */
    'question'?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckCoherenceResponseAnswerResponse
     */
    'questionTableId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckCoherenceResponseAnswerResponse
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface CheckCoherenceResponseCoherenceResponse
 */
export interface CheckCoherenceResponseCoherenceResponse {
    /**
     * 
     * @type {Array<CheckCoherenceResponseAnswerResponse>}
     * @memberof CheckCoherenceResponseCoherenceResponse
     */
    'answerList'?: Array<CheckCoherenceResponseAnswerResponse>;
    /**
     * 
     * @type {string}
     * @memberof CheckCoherenceResponseCoherenceResponse
     */
    'controlCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckCoherenceResponseCoherenceResponse
     */
    'controlDescription'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckCoherenceResponseCoherenceResponse
     */
    'blocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckCoherenceResponseCoherenceResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface FormStrutturaQuestionarioResponse
 */
export interface FormStrutturaQuestionarioResponse {
    /**
     * 
     * @type {Array<FormStrutturaQuestionarioResponseThematicAreaResponse>}
     * @memberof FormStrutturaQuestionarioResponse
     */
    'thematicAreaList'?: Array<FormStrutturaQuestionarioResponseThematicAreaResponse>;
}
/**
 * 
 * @export
 * @interface FormStrutturaQuestionarioResponseQuestionOptionResponse
 */
export interface FormStrutturaQuestionarioResponseQuestionOptionResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof FormStrutturaQuestionarioResponseQuestionOptionResponse
     */
    'conditionList'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormStrutturaQuestionarioResponseQuestionOptionResponse
     */
    'imageList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseQuestionOptionResponse
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseQuestionOptionResponse
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface FormStrutturaQuestionarioResponseQuestionResponse
 */
export interface FormStrutturaQuestionarioResponseQuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'questionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'valorized'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'conditionList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'help'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'readonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'visible'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'imageList'?: Array<string>;
    /**
     * 
     * @type {Array<FormStrutturaQuestionarioResponseQuestionOptionResponse>}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'questionOptionList'?: Array<FormStrutturaQuestionarioResponseQuestionOptionResponse>;
    /**
     * 
     * @type {Array<FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse>}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'questionTableList'?: Array<FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseQuestionResponse
     */
    'compact'?: boolean;
}
/**
 * 
 * @export
 * @interface FormStrutturaQuestionarioResponseSectionResponse
 */
export interface FormStrutturaQuestionarioResponseSectionResponse {
    /**
     * 
     * @type {Array<FormStrutturaQuestionarioResponseQuestionResponse>}
     * @memberof FormStrutturaQuestionarioResponseSectionResponse
     */
    'questionList'?: Array<FormStrutturaQuestionarioResponseQuestionResponse>;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseSectionResponse
     */
    'sectionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseSectionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseSectionResponse
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
 */
export interface FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse {
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'questionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'valorized'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'conditionList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'help'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'readonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'visible'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'imageList'?: Array<string>;
    /**
     * 
     * @type {Array<FormStrutturaQuestionarioResponseQuestionOptionResponse>}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'questionOptionList'?: Array<FormStrutturaQuestionarioResponseQuestionOptionResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'clearOthers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormStrutturaQuestionarioResponseStructuredQuestionsTableResponse
     */
    'setByOthers'?: boolean;
}
/**
 * 
 * @export
 * @interface FormStrutturaQuestionarioResponseThematicAreaResponse
 */
export interface FormStrutturaQuestionarioResponseThematicAreaResponse {
    /**
     * 
     * @type {Array<FormStrutturaQuestionarioResponseSectionResponse>}
     * @memberof FormStrutturaQuestionarioResponseThematicAreaResponse
     */
    'sectionList'?: Array<FormStrutturaQuestionarioResponseSectionResponse>;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseThematicAreaResponse
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseThematicAreaResponse
     */
    'thematicAreaCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormStrutturaQuestionarioResponseThematicAreaResponse
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponse
 */
export interface FormThematicAreaResponse {
    /**
     * 
     * @type {Array<FormThematicAreaResponseThematicAreaResponse>}
     * @memberof FormThematicAreaResponse
     */
    'thematicAreaList'?: Array<FormThematicAreaResponseThematicAreaResponse>;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponse
     */
    'formCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponse
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponse
     */
    'formDescription'?: string;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseQuestionOptionResponse
 */
export interface FormThematicAreaResponseQuestionOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionOptionResponse
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionOptionResponse
     */
    'text'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionOptionResponse
     */
    'conditionList'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseQuestionResponse
 */
export interface FormThematicAreaResponseQuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'questionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'conditionList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'help'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'readonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'visible'?: boolean;
    /**
     * 
     * @type {Array<FormThematicAreaResponseQuestionOptionResponse>}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'questionOptionList'?: Array<FormThematicAreaResponseQuestionOptionResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'imageList'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'valorized'?: boolean;
    /**
     * 
     * @type {Array<FormThematicAreaResponseQuestionsTableResponse>}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'questionTableList'?: Array<FormThematicAreaResponseQuestionsTableResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'compact'?: boolean;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseQuestionsTableResponse
 */
export interface FormThematicAreaResponseQuestionsTableResponse {
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'questionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'conditionList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'help'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'readonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'visible'?: boolean;
    /**
     * 
     * @type {Array<FormThematicAreaResponseQuestionOptionResponse>}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'questionOptionList'?: Array<FormThematicAreaResponseQuestionOptionResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'imageList'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'clearOthers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'setByOthers'?: boolean;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseSectionResponse
 */
export interface FormThematicAreaResponseSectionResponse {
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseSectionResponse
     */
    'sectionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseSectionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseSectionResponse
     */
    'text'?: string;
    /**
     * 
     * @type {Array<FormThematicAreaResponseQuestionResponse>}
     * @memberof FormThematicAreaResponseSectionResponse
     */
    'questionList'?: Array<FormThematicAreaResponseQuestionResponse>;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseThematicAreaResponse
 */
export interface FormThematicAreaResponseThematicAreaResponse {
    /**
     * 
     * @type {Array<FormThematicAreaResponseSectionResponse>}
     * @memberof FormThematicAreaResponseThematicAreaResponse
     */
    'sectionList'?: Array<FormThematicAreaResponseSectionResponse>;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseThematicAreaResponse
     */
    'thematicAreaCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseThematicAreaResponse
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseThematicAreaResponse
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface GetFormThematicAreaParameter
 */
export interface GetFormThematicAreaParameter {
    /**
     * 
     * @type {string}
     * @memberof GetFormThematicAreaParameter
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof GetFormThematicAreaParameter
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof GetFormThematicAreaParameter
     */
    'formCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFormThematicAreaParameter
     */
    'thematicAreaCodeList': Array<string>;
}
/**
 * 
 * @export
 * @interface ProfiloRischioResponseAdditionalResultResponse
 */
export interface ProfiloRischioResponseAdditionalResultResponse {
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseAdditionalResultResponse
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseAdditionalResultResponse
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ProfiloRischioResponseLogStatusResponse
 */
export interface ProfiloRischioResponseLogStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseLogStatusResponse
     */
    'status'?: ProfiloRischioResponseLogStatusResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseLogStatusResponse
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseLogStatusResponse
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseLogStatusResponse
     */
    'user'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseLogStatusResponse
     */
    'sessionToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseLogStatusResponse
     */
    'userRole'?: string;
}

export const ProfiloRischioResponseLogStatusResponseStatusEnum = {
    A: 'A',
    S: 'S',
    P: 'P',
    Sos: 'SOS',
    R: 'R',
    Sus: 'SUS',
    Ex: 'EX',
    D: 'D'
} as const;

export type ProfiloRischioResponseLogStatusResponseStatusEnum = typeof ProfiloRischioResponseLogStatusResponseStatusEnum[keyof typeof ProfiloRischioResponseLogStatusResponseStatusEnum];

/**
 * 
 * @export
 * @interface ProfiloRischioResponseReportRequest
 */
export interface ProfiloRischioResponseReportRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseReportRequest
     */
    'reportCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseReportRequest
     */
    'reportReference'?: string;
}
/**
 * 
 * @export
 * @interface ProfiloRischioResponseResult
 */
export interface ProfiloRischioResponseResult {
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'customerCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'tms'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'formVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'formCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'categorisationRequired'?: ProfiloRischioResponseResultCategorisationRequiredEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'dateInsert'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'status'?: ProfiloRischioResponseResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'idReport'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'dateExpiry'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'categorisationRight'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'knowExperience'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'invObjective'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'horizon'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'financialSituation'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'insuranceNeed'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'esg'?: number;
    /**
     * 
     * @type {Array<QuestionnaireResponseAnswerResponse>}
     * @memberof ProfiloRischioResponseResult
     */
    'answerList'?: Array<QuestionnaireResponseAnswerResponse>;
    /**
     * 
     * @type {Array<ProfiloRischioResponseAdditionalResultResponse>}
     * @memberof ProfiloRischioResponseResult
     */
    'additionalResultList'?: Array<ProfiloRischioResponseAdditionalResultResponse>;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'dateActivation'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'riskProfile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'holdingPeriod'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'delegate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'lossCapacity'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'hpperc1'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'hpperc2'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'hpperc3'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'hpperc4'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'hpperc5'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'initialTolerance'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'liquidityThreshold'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'riskTolerance'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'unlockedByUser'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'customerType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'appliedProfile'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'instituteCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'profilingChannel'?: ProfiloRischioResponseResultProfilingChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'branchCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'branchName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'signatureMode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'expirationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'profilingReason'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfiloRischioResponseResult
     */
    'averageOperations'?: number;
    /**
     * 
     * @type {Array<ProfiloRischioResponseLogStatusResponse>}
     * @memberof ProfiloRischioResponseResult
     */
    'logStatusList'?: Array<ProfiloRischioResponseLogStatusResponse>;
    /**
     * 
     * @type {Array<ProfiloRischioResponseReportRequest>}
     * @memberof ProfiloRischioResponseResult
     */
    'reportList'?: Array<ProfiloRischioResponseReportRequest>;
    /**
     * 
     * @type {string}
     * @memberof ProfiloRischioResponseResult
     */
    'trustworthyType'?: ProfiloRischioResponseResultTrustworthyTypeEnum;
}

export const ProfiloRischioResponseResultCategorisationRequiredEnum = {
    Professionale: 'PROFESSIONALE',
    CnpQualificata: 'CNP_QUALIFICATA',
    Dettaglio: 'DETTAGLIO',
    NonPresente: 'NON_PRESENTE'
} as const;

export type ProfiloRischioResponseResultCategorisationRequiredEnum = typeof ProfiloRischioResponseResultCategorisationRequiredEnum[keyof typeof ProfiloRischioResponseResultCategorisationRequiredEnum];
export const ProfiloRischioResponseResultStatusEnum = {
    A: 'A',
    S: 'S',
    P: 'P',
    Sos: 'SOS',
    R: 'R',
    Sus: 'SUS',
    Ex: 'EX',
    D: 'D'
} as const;

export type ProfiloRischioResponseResultStatusEnum = typeof ProfiloRischioResponseResultStatusEnum[keyof typeof ProfiloRischioResponseResultStatusEnum];
export const ProfiloRischioResponseResultProfilingChannelEnum = {
    Office: 'OFFICE',
    OutOfOffice: 'OUT_OF_OFFICE'
} as const;

export type ProfiloRischioResponseResultProfilingChannelEnum = typeof ProfiloRischioResponseResultProfilingChannelEnum[keyof typeof ProfiloRischioResponseResultProfilingChannelEnum];
export const ProfiloRischioResponseResultTrustworthyTypeEnum = {
    None: 'NONE',
    Pf: 'PF',
    Pg: 'PG',
    Coi: 'COI',
    Fid: 'FID',
    Fis: 'FIS',
    Giu: 'GIU'
} as const;

export type ProfiloRischioResponseResultTrustworthyTypeEnum = typeof ProfiloRischioResponseResultTrustworthyTypeEnum[keyof typeof ProfiloRischioResponseResultTrustworthyTypeEnum];

/**
 * 
 * @export
 * @interface QuestionnaireMifidParamRequest
 */
export interface QuestionnaireMifidParamRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidParamRequest
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidParamRequest
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidParamRequest
     */
    'instituteCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnaireMifidParamRequest
     */
    'withDefaultQuestionnaire'?: boolean;
}
/**
 * 
 * @export
 * @interface QuestionnaireMifidResponse
 */
export interface QuestionnaireMifidResponse {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'returnCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'returnMessage'?: string;
    /**
     * 
     * @type {Array<FormStrutturaQuestionarioResponse>}
     * @memberof QuestionnaireMifidResponse
     */
    'strutturaQuestionario'?: Array<FormStrutturaQuestionarioResponse>;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'customerCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'formCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'formVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'formDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'questionnaireId'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'legalRepresentative'?: string;
    /**
     * 
     * @type {ProfiloRischioResponseResult}
     * @memberof QuestionnaireMifidResponse
     */
    'profiloRischio'?: ProfiloRischioResponseResult;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireMifidResponse
     */
    'instituteCode'?: string;
}
/**
 * 
 * @export
 * @interface QuestionnaireRequestAnswerRequest
 */
export interface QuestionnaireRequestAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireRequestAnswerRequest
     */
    'questionCode': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireRequestAnswerRequest
     */
    'value'?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireRequestAnswerRequest
     */
    'questionTableId': number;
}
/**
 * 
 * @export
 * @interface QuestionnaireResponseAnswerResponse
 */
export interface QuestionnaireResponseAnswerResponse {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireResponseAnswerResponse
     */
    'questionCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireResponseAnswerResponse
     */
    'questionTableId'?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireResponseAnswerResponse
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface UpdateStatusRiskProfileRequestV2
 */
export interface UpdateStatusRiskProfileRequestV2 {
    /**
     * 
     * @type {string}
     * @memberof UpdateStatusRiskProfileRequestV2
     */
    'status': UpdateStatusRiskProfileRequestV2StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateStatusRiskProfileRequestV2
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStatusRiskProfileRequestV2
     */
    'tms': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStatusRiskProfileRequestV2
     */
    'dateExpiry'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStatusRiskProfileRequestV2
     */
    'dateActivation'?: string;
}

export const UpdateStatusRiskProfileRequestV2StatusEnum = {
    A: 'A',
    S: 'S',
    P: 'P',
    R: 'R',
    Sus: 'SUS',
    D: 'D'
} as const;

export type UpdateStatusRiskProfileRequestV2StatusEnum = typeof UpdateStatusRiskProfileRequestV2StatusEnum[keyof typeof UpdateStatusRiskProfileRequestV2StatusEnum];

/**
 * 
 * @export
 * @interface UpdateStatusRiskProfileResponse
 */
export interface UpdateStatusRiskProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateStatusRiskProfileResponse
     */
    'status'?: UpdateStatusRiskProfileResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateStatusRiskProfileResponse
     */
    'instituteCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStatusRiskProfileResponse
     */
    'reason'?: string;
}

export const UpdateStatusRiskProfileResponseStatusEnum = {
    A: 'A',
    S: 'S',
    P: 'P',
    R: 'R',
    Sus: 'SUS',
    D: 'D'
} as const;

export type UpdateStatusRiskProfileResponseStatusEnum = typeof UpdateStatusRiskProfileResponseStatusEnum[keyof typeof UpdateStatusRiskProfileResponseStatusEnum];

/**
 * 
 * @export
 * @interface WriteQuestionnaireMifidRequest
 */
export interface WriteQuestionnaireMifidRequest {
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'formCode': string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'questionnaireId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'instituteCode': string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'categorisationRight': WriteQuestionnaireMifidRequestCategorisationRightEnum;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'categorisationRequired'?: WriteQuestionnaireMifidRequestCategorisationRequiredEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'save'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'calculate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'dateExpiry'?: string;
    /**
     * 
     * @type {Array<QuestionnaireRequestAnswerRequest>}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'answerList'?: Array<QuestionnaireRequestAnswerRequest>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'thematicAreaList': Array<string>;
    /**
     * 
     * @type {Array<WriteQuestionnaireMifidRequestAdditionalResults>}
     * @memberof WriteQuestionnaireMifidRequest
     */
    'additionalResultsList'?: Array<WriteQuestionnaireMifidRequestAdditionalResults>;
}

export const WriteQuestionnaireMifidRequestCategorisationRightEnum = {
    Professionale: 'PROFESSIONALE',
    CnpQualificata: 'CNP_QUALIFICATA',
    Dettaglio: 'DETTAGLIO',
    NonPresente: 'NON_PRESENTE'
} as const;

export type WriteQuestionnaireMifidRequestCategorisationRightEnum = typeof WriteQuestionnaireMifidRequestCategorisationRightEnum[keyof typeof WriteQuestionnaireMifidRequestCategorisationRightEnum];
export const WriteQuestionnaireMifidRequestCategorisationRequiredEnum = {
    Professionale: 'PROFESSIONALE',
    CnpQualificata: 'CNP_QUALIFICATA',
    Dettaglio: 'DETTAGLIO',
    NonPresente: 'NON_PRESENTE'
} as const;

export type WriteQuestionnaireMifidRequestCategorisationRequiredEnum = typeof WriteQuestionnaireMifidRequestCategorisationRequiredEnum[keyof typeof WriteQuestionnaireMifidRequestCategorisationRequiredEnum];

/**
 * 
 * @export
 * @interface WriteQuestionnaireMifidRequestAdditionalResults
 */
export interface WriteQuestionnaireMifidRequestAdditionalResults {
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequestAdditionalResults
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidRequestAdditionalResults
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface WriteQuestionnaireMifidResponse
 */
export interface WriteQuestionnaireMifidResponse {
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'returnCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'returnMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'questionnaireId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'formCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'formVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'formDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'dateInsert'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'canSave'?: boolean;
    /**
     * 
     * @type {FormStrutturaQuestionarioResponse}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'strutturaQuestionario'?: FormStrutturaQuestionarioResponse;
    /**
     * 
     * @type {Array<CheckCoherenceResponseCoherenceResponse>}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'coherenceList'?: Array<CheckCoherenceResponseCoherenceResponse>;
    /**
     * 
     * @type {Array<QuestionnaireResponseAnswerResponse>}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'answerList'?: Array<QuestionnaireResponseAnswerResponse>;
    /**
     * 
     * @type {ProfiloRischioResponseResult}
     * @memberof WriteQuestionnaireMifidResponse
     */
    'profiloRischio'?: ProfiloRischioResponseResult;
}

/**
 * CustomersControllerApi - axios parameter creator
 * @export
 */
export const CustomersControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {string} customerCode 
         * @param {string} source 
         * @param {string} language 
         * @param {string} [instituteCode] 
         * @param {string} [withDefaultQuestionnaire] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaireMifid: async (tenant: string, customerCode: string, source: string, language: string, instituteCode?: string, withDefaultQuestionnaire?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('getQuestionnaireMifid', 'tenant', tenant)
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('getQuestionnaireMifid', 'customerCode', customerCode)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('getQuestionnaireMifid', 'source', source)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getQuestionnaireMifid', 'language', language)
            const localVarPath = `/profiling/v1/customers/{customerCode}/questionnaire-mifid`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication devstoreCustomer required
            await setApiKeyToObject(localVarHeaderParameter, "devstore.customer", configuration)

            // authentication externalAuth required
            await setApiKeyToObject(localVarHeaderParameter, "external", configuration)

            // authentication xSessionContext required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Context", configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (instituteCode !== undefined) {
                localVarQueryParameter['instituteCode'] = instituteCode;
            }

            if (withDefaultQuestionnaire !== undefined) {
                localVarQueryParameter['withDefaultQuestionnaire'] = withDefaultQuestionnaire;
            }

            if (tenant != null) {
                localVarHeaderParameter['tenant'] = String(tenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerCode 
         * @param {string} tenant 
         * @param {WriteQuestionnaireMifidRequest} writeQuestionnaireMifidRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeQuestionnaireMifid: async (customerCode: string, tenant: string, writeQuestionnaireMifidRequest: WriteQuestionnaireMifidRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('writeQuestionnaireMifid', 'customerCode', customerCode)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('writeQuestionnaireMifid', 'tenant', tenant)
            // verify required parameter 'writeQuestionnaireMifidRequest' is not null or undefined
            assertParamExists('writeQuestionnaireMifid', 'writeQuestionnaireMifidRequest', writeQuestionnaireMifidRequest)
            const localVarPath = `/profiling/v1/customers/{customerCode}/questionnaire-mifid`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication devstoreCustomer required
            await setApiKeyToObject(localVarHeaderParameter, "devstore.customer", configuration)

            // authentication externalAuth required
            await setApiKeyToObject(localVarHeaderParameter, "external", configuration)

            // authentication xSessionContext required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Context", configuration)

            if (tenant != null) {
                localVarHeaderParameter['tenant'] = String(tenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeQuestionnaireMifidRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersControllerApi - functional programming interface
 * @export
 */
export const CustomersControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {string} customerCode 
         * @param {string} source 
         * @param {string} language 
         * @param {string} [instituteCode] 
         * @param {string} [withDefaultQuestionnaire] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionnaireMifid(tenant: string, customerCode: string, source: string, language: string, instituteCode?: string, withDefaultQuestionnaire?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireMifidResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionnaireMifid(tenant, customerCode, source, language, instituteCode, withDefaultQuestionnaire, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} customerCode 
         * @param {string} tenant 
         * @param {WriteQuestionnaireMifidRequest} writeQuestionnaireMifidRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async writeQuestionnaireMifid(customerCode: string, tenant: string, writeQuestionnaireMifidRequest: WriteQuestionnaireMifidRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WriteQuestionnaireMifidResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.writeQuestionnaireMifid(customerCode, tenant, writeQuestionnaireMifidRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomersControllerApi - factory interface
 * @export
 */
export const CustomersControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {string} customerCode 
         * @param {string} source 
         * @param {string} language 
         * @param {string} [instituteCode] 
         * @param {string} [withDefaultQuestionnaire] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaireMifid(tenant: string, customerCode: string, source: string, language: string, instituteCode?: string, withDefaultQuestionnaire?: string, options?: any): AxiosPromise<QuestionnaireMifidResponse> {
            return localVarFp.getQuestionnaireMifid(tenant, customerCode, source, language, instituteCode, withDefaultQuestionnaire, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerCode 
         * @param {string} tenant 
         * @param {WriteQuestionnaireMifidRequest} writeQuestionnaireMifidRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeQuestionnaireMifid(customerCode: string, tenant: string, writeQuestionnaireMifidRequest: WriteQuestionnaireMifidRequest, options?: any): AxiosPromise<WriteQuestionnaireMifidResponse> {
            return localVarFp.writeQuestionnaireMifid(customerCode, tenant, writeQuestionnaireMifidRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersControllerApi - object-oriented interface
 * @export
 * @class CustomersControllerApi
 * @extends {BaseAPI}
 */
export class CustomersControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} tenant 
     * @param {string} customerCode 
     * @param {string} source 
     * @param {string} language 
     * @param {string} [instituteCode] 
     * @param {string} [withDefaultQuestionnaire] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersControllerApi
     */
    public getQuestionnaireMifid(tenant: string, customerCode: string, source: string, language: string, instituteCode?: string, withDefaultQuestionnaire?: string, options?: AxiosRequestConfig) {
        return CustomersControllerApiFp(this.configuration).getQuestionnaireMifid(tenant, customerCode, source, language, instituteCode, withDefaultQuestionnaire, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerCode 
     * @param {string} tenant 
     * @param {WriteQuestionnaireMifidRequest} writeQuestionnaireMifidRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersControllerApi
     */
    public writeQuestionnaireMifid(customerCode: string, tenant: string, writeQuestionnaireMifidRequest: WriteQuestionnaireMifidRequest, options?: AxiosRequestConfig) {
        return CustomersControllerApiFp(this.configuration).writeQuestionnaireMifid(customerCode, tenant, writeQuestionnaireMifidRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomersControllerV2Api - axios parameter creator
 * @export
 */
export const CustomersControllerV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {string} customerCode 
         * @param {UpdateStatusRiskProfileRequestV2} updateStatusRiskProfileRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatusRiskProfile: async (tenant: string, customerCode: string, updateStatusRiskProfileRequestV2: UpdateStatusRiskProfileRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('updateStatusRiskProfile', 'tenant', tenant)
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('updateStatusRiskProfile', 'customerCode', customerCode)
            // verify required parameter 'updateStatusRiskProfileRequestV2' is not null or undefined
            assertParamExists('updateStatusRiskProfile', 'updateStatusRiskProfileRequestV2', updateStatusRiskProfileRequestV2)
            const localVarPath = `/profiling/v2/customers/{customerCode}/risk-profile`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication devstoreCustomer required
            await setApiKeyToObject(localVarHeaderParameter, "devstore.customer", configuration)

            // authentication externalAuth required
            await setApiKeyToObject(localVarHeaderParameter, "external", configuration)

            // authentication xSessionContext required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Context", configuration)

            if (tenant != null) {
                localVarHeaderParameter['tenant'] = String(tenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStatusRiskProfileRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersControllerV2Api - functional programming interface
 * @export
 */
export const CustomersControllerV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersControllerV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {string} customerCode 
         * @param {UpdateStatusRiskProfileRequestV2} updateStatusRiskProfileRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatusRiskProfile(tenant: string, customerCode: string, updateStatusRiskProfileRequestV2: UpdateStatusRiskProfileRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateStatusRiskProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatusRiskProfile(tenant, customerCode, updateStatusRiskProfileRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomersControllerV2Api - factory interface
 * @export
 */
export const CustomersControllerV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersControllerV2ApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {string} customerCode 
         * @param {UpdateStatusRiskProfileRequestV2} updateStatusRiskProfileRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatusRiskProfile(tenant: string, customerCode: string, updateStatusRiskProfileRequestV2: UpdateStatusRiskProfileRequestV2, options?: any): AxiosPromise<UpdateStatusRiskProfileResponse> {
            return localVarFp.updateStatusRiskProfile(tenant, customerCode, updateStatusRiskProfileRequestV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersControllerV2Api - object-oriented interface
 * @export
 * @class CustomersControllerV2Api
 * @extends {BaseAPI}
 */
export class CustomersControllerV2Api extends BaseAPI {
    /**
     * 
     * @param {string} tenant 
     * @param {string} customerCode 
     * @param {UpdateStatusRiskProfileRequestV2} updateStatusRiskProfileRequestV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersControllerV2Api
     */
    public updateStatusRiskProfile(tenant: string, customerCode: string, updateStatusRiskProfileRequestV2: UpdateStatusRiskProfileRequestV2, options?: AxiosRequestConfig) {
        return CustomersControllerV2ApiFp(this.configuration).updateStatusRiskProfile(tenant, customerCode, updateStatusRiskProfileRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FormControllerApi - axios parameter creator
 * @export
 */
export const FormControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {GetFormThematicAreaParameter} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormThematicArea: async (tenant: string, request: GetFormThematicAreaParameter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('getFormThematicArea', 'tenant', tenant)
            // verify required parameter 'request' is not null or undefined
            assertParamExists('getFormThematicArea', 'request', request)
            const localVarPath = `/profiling/v1/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication devstoreCustomer required
            await setApiKeyToObject(localVarHeaderParameter, "devstore.customer", configuration)

            // authentication externalAuth required
            await setApiKeyToObject(localVarHeaderParameter, "external", configuration)

            // authentication xSessionContext required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Context", configuration)

            if (request !== undefined) {
                localVarQueryParameter['request'] = request;
            }

            if (tenant != null) {
                localVarHeaderParameter['tenant'] = String(tenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormControllerApi - functional programming interface
 * @export
 */
export const FormControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {GetFormThematicAreaParameter} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormThematicArea(tenant: string, request: GetFormThematicAreaParameter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormThematicAreaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormThematicArea(tenant, request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FormControllerApi - factory interface
 * @export
 */
export const FormControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {GetFormThematicAreaParameter} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormThematicArea(tenant: string, request: GetFormThematicAreaParameter, options?: any): AxiosPromise<FormThematicAreaResponse> {
            return localVarFp.getFormThematicArea(tenant, request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormControllerApi - object-oriented interface
 * @export
 * @class FormControllerApi
 * @extends {BaseAPI}
 */
export class FormControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} tenant 
     * @param {GetFormThematicAreaParameter} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormControllerApi
     */
    public getFormThematicArea(tenant: string, request: GetFormThematicAreaParameter, options?: AxiosRequestConfig) {
        return FormControllerApiFp(this.configuration).getFormThematicArea(tenant, request, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GovernanceControllerApi - axios parameter creator
 * @export
 */
export const GovernanceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleImage: async (tenant: string, key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('getSingleImage', 'tenant', tenant)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getSingleImage', 'key', key)
            const localVarPath = `/profiling/v1/images/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication devstoreCustomer required
            await setApiKeyToObject(localVarHeaderParameter, "devstore.customer", configuration)

            // authentication externalAuth required
            await setApiKeyToObject(localVarHeaderParameter, "external", configuration)

            // authentication xSessionContext required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Context", configuration)

            if (tenant != null) {
                localVarHeaderParameter['tenant'] = String(tenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GovernanceControllerApi - functional programming interface
 * @export
 */
export const GovernanceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GovernanceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSingleImage(tenant: string, key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSingleImage(tenant, key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GovernanceControllerApi - factory interface
 * @export
 */
export const GovernanceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GovernanceControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenant 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleImage(tenant: string, key: string, options?: any): AxiosPromise<File> {
            return localVarFp.getSingleImage(tenant, key, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GovernanceControllerApi - object-oriented interface
 * @export
 * @class GovernanceControllerApi
 * @extends {BaseAPI}
 */
export class GovernanceControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} tenant 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GovernanceControllerApi
     */
    public getSingleImage(tenant: string, key: string, options?: AxiosRequestConfig) {
        return GovernanceControllerApiFp(this.configuration).getSingleImage(tenant, key, options).then((request) => request(this.axios, this.basePath));
    }
}


